import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import { isString } from "lodash-es";
export const LinesWithBreaks = ({ lines }) => {
    return (_jsx(_Fragment, { children: lines
            .map(line => (isString(line) ? line.trim() : line))
            .map((item, idx, array) => (_jsxs(React.Fragment, { children: [item, idx < array.length - 1 ? _jsx("br", {}) : null] }, idx))) }));
};
//# sourceMappingURL=LinesWithBreaks.js.map